import {
    BannersEditMassActions,
    CLOSE_MASS_ACTIONS_VIDEO_BULK_REPLACEMENT_EDITOR,
    ON_ACCEPT_MASS_ACTIONS_VIDEO_BULK_REPLACEMENT_EDITOR,
    ON_MASS_ACTIONS_VIDEO_BULK_REPLACEMENT_EDITOR_RADIO_BUTTON_STATE_CHANGED,
    OPEN_MASS_ACTIONS_VIDEO_BULK_REPLACEMENT_EDITOR
} from '../../../actions/banners-edit/banners-edit-mass-actions';
import { BannersEditMassActionsState } from '../../../typings/bannersEditState';
import { State } from '../../../typings/state';

import { bannersEditMassActionsInitialState } from './banners-edit-mass-actions';

export function bannersEditMassActionsVideoReplaceReducer(
    state: BannersEditMassActionsState = bannersEditMassActionsInitialState,
    action: BannersEditMassActions,
    fullState: State
): BannersEditMassActionsState {
    switch (action.type) {
        case ON_ACCEPT_MASS_ACTIONS_VIDEO_BULK_REPLACEMENT_EDITOR:
        case CLOSE_MASS_ACTIONS_VIDEO_BULK_REPLACEMENT_EDITOR:
            return bannersEditMassActionsInitialState;
        case OPEN_MASS_ACTIONS_VIDEO_BULK_REPLACEMENT_EDITOR: {
            return {
                ...state,
                [action.massActionId]: {
                    ...state[action.massActionId],
                    visibleModalActions: {
                        ...state[action.massActionId].visibleModalActions,
                        videoBulkReplacementEditorVisible: true
                    }
                }
            };
        }
        case ON_MASS_ACTIONS_VIDEO_BULK_REPLACEMENT_EDITOR_RADIO_BUTTON_STATE_CHANGED: {
            return {
                ...state,
                [action.massActionId]: {
                    ...state[action.massActionId],
                    data: {
                        ...state[action.massActionId].data,
                        currentActiveRadioButtonVideo: action.value
                    }
                }
            };
        }
        default:
            return state;
    }
}
